export const limitedCompanyBusinessTypeFields = [
    'company.company_name',
    'company.company_number',
    'company.annual_turnover',
    'company.monthly_turnover',
    'company.website',
    'company.registered.mm',
    'company.registered.yy',
    'company.vat_registered_status'
];

export const soleTraderBusinessTypeFields = [
    'company.trading_as',
    'company.registered.mm',
    'company.registered.yy',
    'company.annual_turnover',
    'company.annual_business_profit',
    'company.website',
    'company.industry',
    'company.vat_registered_status'
];

export const businessTypeFields = ['company.type'];
